var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.1,489.5c-3.6,0-7.1-1.5-9.5-4.1L29.9,245.7c-2.2-2.1-3.6-4.8-4.2-7.8L10.6,124.8c-0.5-4.4,1.1-8.7,3.9-11.2l0.1-0.1 l98.8-98.8c2.6-2.7,6.2-4.2,9.9-4.2c0.5,0,1,0,1.5,0.1L238,25.7c2.8,0.3,5.5,1.6,7.4,3.8l0.2,0.2l239.8,239.9 c2.7,2.6,4.2,6.2,4.1,10c-0.1,3.4-1.5,6.6-4,8.9l-0.1,0.1L288.6,485.4C286.2,488,282.7,489.5,279.1,489.5z M38.9,128l13.2,101.8 l227,227l177.7-177.7l-227-227L128,38.3L38.9,128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.9,196.5c-3.6,0-7.1-1.5-9.5-4.1c-2.7-2.6-4.2-6.2-4.1-10c0.1-3.4,1.5-6.6,4-8.9l0.1-0.1l64.2-64.2 c2.6-2.6,6.1-4.1,9.8-4.1c3.5,0,6.8,1.4,9.2,4l0.1,0.1c2.7,2.6,4.2,6.2,4.1,10c-0.1,3.4-1.5,6.6-4,8.9l-0.1,0.1l-64.1,64.2 C130,195,126.6,196.5,122.9,196.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 500,
    height: 500
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagDark);
export default __webpack_public_path__ + "static/media/tag_dark.7a27b7398c480e07d4c9418cff5b43b6.svg";
export { ForwardRef as ReactComponent };